export default {
  title: 'Automations',
  description: 'Run agents on a schedule.',
  createAutomation: 'Create automation',
  editAutomation: 'Edit automation',
  scheduleFormDescription: 'Choose when the agent should run.',
  laplaceDefault: 'Laplace',
  agent: 'Agent',
  workspace: 'Workspace',
  name: 'Name',
  namePlaceholder: 'For example, Weekly report',
  schedule: 'Schedule',
  scheduleInput: 'When to run',
  schedulePlaceholder: 'Every Monday at 9:00',
  interpretingSchedule: 'Checking the schedule...',
  scheduleUnderstood: 'Schedule understood',
  scheduleInvalid: 'Unable to understand this schedule.',
  schedulePreviewFailed: 'Unable to check the schedule.',
  nextRunsPreview: 'Next runs: {{dates}}',
  timezone: 'Timezone',
  prompt: 'Task for each run',
  promptDescription:
    'Describe the work to perform on this schedule. Do not repeat the agent’s permanent instructions — provide the scope, input data, and expected result.',
  promptPlaceholder:
    'For example: review new emails from the past week, highlight important ones, and prepare a short summary.',
  cancel: 'Cancel',
  save: 'Save',
  saving: 'Saving...',
  search: 'Search automations',
  allWorkspaces: 'All workspaces',
  allStatuses: 'All statuses',
  active: 'Active',
  paused: 'Off',
  provisioning: 'Setting up',
  error: 'Error',
  automation: 'Automation',
  status: 'Status',
  nextRun: 'Next run',
  lastRun: 'Last run',
  never: 'Never',
  disable: 'Turn off',
  enable: 'Turn on',
  edit: 'Edit',
  delete: 'Delete',
  empty: 'No automations yet.',
  noResults: 'No automations match your filters.',
  loadFailed: 'Unable to load automations.',
  retry: 'Retry',
  openChat: 'Open chat',
  deleteTitle: 'Delete automation?',
  deleteDescription: '“{{name}}” and its configuration will be deleted.',
  automationCreated: 'Automation created',
  automationUpdated: 'Automation updated',
  automationDeleted: 'Automation deleted',
  actionFailed: 'Unable to complete the action',
  saveFailed: 'Unable to save automation',
}
